import type { ErrorSeverity } from './types';

export function computeClientFingerprint(
  source: string,
  name: string | undefined,
  message: string | undefined,
  scope: { severity: ErrorSeverity; host?: string; path?: string }
): string {
  let normalized = [source, name ?? '', message ?? '']
    .map((part) => part.trim().toLowerCase())
    .join('|');

  // Keep ordinary error identities stable while retaining severity changes and
  // distinct resources. Paths are case-sensitive; URLs are already sanitized.
  if (scope.severity !== 'error') normalized += `|severity:${scope.severity}`;
  if (scope.host || scope.path) {
    normalized += `|resource:${JSON.stringify([scope.host ?? '', scope.path ?? ''])}`;
  }

  let hash = 0;
  for (let i = 0; i < normalized.length; i += 1) {
    hash = (hash << 5) - hash + normalized.charCodeAt(i);
    hash |= 0;
  }
  return `fp_${Math.abs(hash).toString(36)}`;
}
